import { LoaderFunction, useFetcher } from "react-router-dom";
import { activateAsset } from "../../../../../common/api/bridge/methods";

export interface ActivateResult {
  ok: boolean;
  asset?: VST.Bridge.Asset;
}

export const activateAction: LoaderFunction = async ({
  params,
  request,
}): Promise<ActivateResult> => {
  if (params.vbid) {
    const formData = await request.formData();
    const credit = formData.get("credit") as string;

    try {
      const bridgeResponse = await activateAsset(params.vbid, credit);

      if (bridgeResponse.status === 200) {
        return {
          ok: true,
          asset: {
            ...bridgeResponse.asset,
            returnable: bridgeResponse.credit.returnable,
          },
        };
      }
    } catch {
      // Fall through to default ok: false at the end
    }
  }

  return { ok: false };
};

export function useAssetActivateFetcher() {
  return useFetcher<ActivateResult>();
}
